import * as React from 'react'

import { cn } from '@/lib/cn'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-10 w-full min-w-0 rounded-sm border border-rule bg-paper px-3 py-2 font-sans text-sm text-ink outline-none transition-[color,box-shadow]',
        'placeholder:text-graphite',
        'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-sans file:text-sm file:font-medium file:text-ink',
        'focus-visible:border-ink focus-visible:ring-2 focus-visible:ring-salmon focus-visible:ring-offset-2 focus-visible:ring-offset-paper',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
